var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.15825 5.71217L8.7556 4.80619C8.49232 4.21382 8.36068 3.91762 8.1638 3.69095C7.91707 3.40688 7.59547 3.19788 7.23567 3.08779C6.94858 2.99994 6.62446 2.99994 5.97621 2.99994C5.02791 2.99994 4.55375 2.99994 4.15573 3.18223C3.68687 3.39696 3.26343 3.86322 3.09473 4.35054C2.95151 4.76423 2.99253 5.18937 3.07458 6.03964C3.94791 15.0901 8.90981 20.052 17.9603 20.9254C18.8106 21.0074 19.2357 21.0484 19.6494 20.9052C20.1367 20.7365 20.603 20.3131 20.8177 19.8442C21 19.4462 21 18.972 21 18.0237C21 17.3755 21 17.0514 20.9122 16.7643C20.8021 16.4045 20.5931 16.0829 20.309 15.8361C20.0823 15.6393 19.7861 15.5076 19.1937 15.2443L18.2878 14.8417C17.6462 14.5566 17.3255 14.414 16.9995 14.383C16.6876 14.3533 16.3731 14.3971 16.0811 14.5108C15.776 14.6296 15.5063 14.8543 14.967 15.3038C14.4301 15.7511 14.1617 15.9748 13.8337 16.0946C13.543 16.2009 13.1586 16.2402 12.8523 16.1951C12.5069 16.1442 12.2423 16.0028 11.7133 15.7201C10.0672 14.8404 9.15953 13.9327 8.27986 12.2867C7.99714 11.7576 7.85578 11.4931 7.80487 11.1476C7.75974 10.8414 7.79908 10.457 7.9053 10.1662C8.02512 9.83822 8.24881 9.5698 8.69619 9.03294C9.14562 8.49362 9.37034 8.22396 9.48915 7.91885C9.60285 7.62688 9.64661 7.31234 9.61694 7.00042C9.58594 6.67446 9.44338 6.3537 9.15825 5.71217Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.a8a1b84a11398de43f245f8e49c7efc7.svg";
export { ForwardRef as ReactComponent };